<template>
  <IdfNewsLetterSubscription
    :title="i18n._('Restez informés !')"
    :content="i18n._('Recevez gratuitement par mail, l\'essentiel de l\'information agricole.')"
    :cta="i18n._('S\'inscrire à la newsletter')"
    class="p-newsletter-subscription"
    mode="column"
    @cta-click="onNewsletterCtaClick"
  >
    <template #illustration>
      <adn-image
        class="p-newsletter-subscription__image"
        :source="imageSources"
        alt="illustration de newsletter"
        loading="eager"
      />
    </template>
    <template #modalbody>
      <c-form-contact
        ref="newsletterform"
        form-id="811dd8c6-9c18-403d-80f5-256aabde44a8"
        portal-id="5942000"
        :target-id="formTargetId"
        :lazyload="false"
        submitted-event="Article_hub_newsLetterFormSubmitted"
      />
    </template>
  </IdfNewsLetterSubscription>
</template>

<script>
import { defineComponent } from 'vue'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import CFormContact from '@b2ag/marketing/src/application/components/CFormContact/CFormContact.vue'
import { i18n } from '@b2ag/locale'
import IdfNewsLetterSubscription from '@b2ag/design-system/src/components/IdfNewsletterSubscription/IdfNewsletterSubscription.vue'
import AdnImage from '@b2ag/design-system/src/components/AdnImage/AdnImage.vue'
import hubnewsletterImage from '../../assets/images/hubnewsletter.jpg'

export default defineComponent({
  name: 'PNewsletterSubscription',
  components: { CFormContact, IdfNewsLetterSubscription, AdnImage },
  props: {
    formTargetId: {
      type: String,
      default: 'newsletter',
    },
  },
  setup() {
    const ILLUSTRATION_PATH = hubnewsletterImage
    const imageSources = [
      {
        url: ILLUSTRATION_PATH,
        media: `(min-width:361px) and (max-width:480px)`,
        additionalOptions: `w_450,q_auto,f_auto,c_pad,dpr_auto`,
      },
      {
        url: ILLUSTRATION_PATH,
        media: `(min-width:481px)`,
        additionalOptions: `w_280,q_auto,f_auto,c_pad,dpr_auto`,
      },
      { url: ILLUSTRATION_PATH, additionalOptions: `w_360,q_auto,f_auto,c_pad,dpr_auto` },
    ]

    function onNewsletterCtaClick() {
      useAnalyticService().trackEvent('Article_hub_newsLetterCTAClick', {})
    }

    return {
      i18n,
      imageSources,
      onNewsletterCtaClick,
    }
  },
})
</script>

<style lang="scss">
.p-newsletter-subscription {
  img.p-newsletter-subscription__image,
  .p-newsletter-subscription__image img {
    max-height: 15rem;
  }
}
</style>
